'use client'

import * as React from 'react'
import { useTranslations } from 'next-intl'

import { SiteFooter } from './site-footer'
import { SiteHeader } from './site-header'
import './desktop-marketing.css'

export function DesktopSkipToContent() {
  const t = useTranslations('studio-desktop-landing-pages.lps.shared')

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-2 focus:bg-sd-accent focus:px-4 focus:py-2 focus:text-studio-gray-1000"
    >
      {t('skipToContent')}
    </a>
  )
}

const defaultHeader = <SiteHeader />
const defaultSkipLink = <DesktopSkipToContent />

export function DesktopBody({ children }: { children: React.ReactNode }) {
  return <main id="main-content">{children}</main>
}

/**
 * Page shell for every Studio Desktop landing page. `header` and `skipLink`
 * default to the Next marketing chrome; a host can pass `null` and mount its
 * own chrome outside this tree.
 */
export function MarketingShell({
  header = defaultHeader,
  skipLink = defaultSkipLink,
  children,
}: {
  header?: React.ReactNode
  skipLink?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <div
      data-desktop-marketing
      data-studio-theme="dark"
      className="min-h-full bg-sd-surface font-normal text-sd-ink antialiased"
    >
      {skipLink}
      {header}
      <DesktopBody>{children}</DesktopBody>
      <SiteFooter />
    </div>
  )
}
